import { jsx } from '@emotion/core';
import { IconContainer } from '../../../Common';
import { AmexCvvIconV2, CvvIconV2, CvvIconV3 } from './Icons';
export var CardCvvIcon = _ref => {
  var {
    ariaDescribedByContent,
    ariaDescribedById,
    cardType,
    isLeft,
    isV2,
    styleOverrides
  } = _ref;
  var CvvIconComponent = CvvIconV3;

  if (cardType === 'AMEX') {
    CvvIconComponent = AmexCvvIconV2;
  } else if (isV2) {
    CvvIconComponent = CvvIconV2;
  }

  return jsx(IconContainer, {
    css: styleOverrides,
    height: "18px",
    isLeft: isLeft,
    width: "29px"
  }, jsx(CvvIconComponent, {
    ariaDescribedByContent: ariaDescribedByContent,
    ariaDescribedById: ariaDescribedById
  }));
};